import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/apply_record_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  user_id_eq: {
    column_type: 'belongs_to',
    column_name: 'user',
    extra: {
      model_name: 'User',
    },
    model_name: 'ApplyRecord',
  },
  user: {
    column_type: 'belongs_to',
    column_name: 'user',
    extra: {
      model_name: 'User',
    },
    model_name: 'ApplyRecord',
  },
  target_id_eq: {
    model_name: 'ApplyRecord',
    column_type: 'string',
    column_name: 'targetId',
  },
  target_of_Post_type_type_eq: {
    column_type: 'type',
    extra: {
      options: ['YouthCamp', 'BookClub'],
    },
    model_name: 'Post',
    column_name: 'type',
  },
  state_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'ApplyRecord',
      options: ['applied', 'paid', 'refund_audit', 'refunding', 'refunded'],
    },
    model_name: 'ApplyRecord',
    column_name: 'state',
  },
  student_id_eq: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'id',
  },
  price_type_name_cont: {
    model_name: 'ApplyRecord',
    column_type: 'string',
    column_name: 'priceTypeName',
  },
  price_type_amount_gteq: {
    model_name: 'ApplyRecord',
    column_type: 'string',
    column_name: 'priceTypeAmount',
  },
  price_type_amount_lteq: {
    model_name: 'ApplyRecord',
    column_type: 'string',
    column_name: 'priceTypeAmount',
  },
  refund_reason_id_eq: {
    column_type: 'belongs_to',
    column_name: 'refund_reason',
    extra: {
      model_name: 'Reason',
    },
    model_name: 'ApplyRecord',
  },
  refund_reason: {
    column_type: 'belongs_to',
    column_name: 'refund_reason',
    extra: {
      model_name: 'Reason',
    },
    model_name: 'ApplyRecord',
  },
  refund_reason_detail_cont: {
    model_name: 'ApplyRecord',
    column_type: 'string',
    column_name: 'refundReasonDetail',
  },
  city_cont: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'city',
  },
  gender_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'Student',
      options: ['unknown', 'male', 'female'],
    },
    model_name: 'Student',
    column_name: 'gender',
  },
  occupation_cont: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'occupation',
  },
  nps_source_cont: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'npsSource',
  },
  courses_count_gteq: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'coursesCount',
  },
  courses_count_lteq: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'coursesCount',
  },
  nps_list_cont: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'npsList',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return entityColumnsExtend(shareColumnsExtend('ApplyRecord', columns), { filterColumnsExtend })
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('ApplyRecord', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
